class MobileGenderTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab.dataset.tab));
      tab.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(tab);
        const last = this.tabs.length - 1;
        const next = { ArrowRight: (index + 1) % this.tabs.length, ArrowLeft: (index + last) % this.tabs.length, Home: 0, End: last }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.select(this.tabs[next].dataset.tab);
        this.tabs[next].focus();
      });
    });

    let saved = null;
    try {
      saved = window.localStorage.getItem('fr-mobile-gender-tab');
    } catch (error) {
      saved = null;
    }

    if (saved === 'women' || saved === 'men') {
      this.select(saved, false);
    }
  }

  select(name, persist = true) {
    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', tab.dataset.tab === name ? 'true' : 'false');
      tab.tabIndex = tab.dataset.tab === name ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.panel !== name;
    });

    if (persist) {
      try {
        window.localStorage.setItem('fr-mobile-gender-tab', name);
      } catch (error) {
        /* localStorage unavailable, ignore */
      }
    }
  }
}

if (!customElements.get('mobile-gender-tabs')) {
  customElements.define('mobile-gender-tabs', MobileGenderTabs);
}
